import React, { useEffect, useContext } from 'react';
import classnames from 'classnames';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import { PopupContext } from '../../../Popup/PopupContext';
import s from './PopperLayout.scss';
export var PopperLayout = function (_a) {
    var style = _a.style, placement = _a.placement, rootRef = _a.rootRef, contentRef = _a.contentRef, outOfBoundaries = _a.outOfBoundaries, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, arrowClassName = _a.arrowClassName, contentClassName = _a.contentClassName, width = _a.width, height = _a.height, showArrow = _a.showArrow, arrowProps = _a.arrowProps, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClickOutside = _a.onClickOutside, scheduleUpdate = _a.scheduleUpdate, directionalClassNames = _a.directionalClassNames, onKeyDown = _a.onKeyDown, role = _a.role, ariaLabel = _a["aria-label"], simpleArrowPosition = _a.simpleArrowPosition;
    useOnOutsideClick([contentRef], function (e) {
        onClickOutside && onClickOutside(e);
    });
    var isInPopup = useContext(PopupContext).isInPopup;
    useEffect(function () {
        scheduleUpdate();
    }, [
        showArrow,
        height,
        width,
        className,
        wrapperClassName,
        contentClassName,
        arrowClassName,
        scheduleUpdate,
    ]);
    var getArrowPosition = function (position, containerSize) {
        if (simpleArrowPosition) {
            return position;
        }
        var arrowSize = parseInt(s['arrow_size']);
        var highLimit = containerSize - arrowSize * 2;
        var lowLimit = arrowSize;
        // The offset adjusts the arrow to point correctly to the reference.
        // We need this because our arrow is not centered by design.
        var offset = placement.startsWith('top') || placement.startsWith('left')
            ? arrowSize / 2
            : -arrowSize / 2;
        return Math.max(lowLimit, Math.min(highLimit, position + offset));
    };
    var getArrowPositionStyles = function (arrowProperties) {
        var contentNode = contentRef && contentRef.current;
        var contentWidth = contentNode && contentNode.clientWidth;
        var contentHeight = contentNode && contentNode.clientHeight;
        var _a = arrowProperties.style, left = _a.left, top = _a.top;
        if (Number.isInteger(left) && contentWidth) {
            left = getArrowPosition(left, contentWidth);
        }
        else if (Number.isInteger(top) && contentHeight) {
            top = getArrowPosition(top, contentHeight);
        }
        return { left: left, top: top };
    };
    return (React.createElement("div", { ref: rootRef, style: style, className: classnames(s['root'], placement && s[placement], outOfBoundaries && s['out-of-bounds'], directionalClassNames && directionalClassNames[placement], showArrow && s['with-arrow'], isInPopup && s['in-popup'], className), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, 
        // So we can focus the content wrapper when it mounts if necessary
        tabIndex: -1, role: role, "aria-label": ariaLabel },
        React.createElement("div", { ref: contentRef, style: {
                width: width,
                height: height,
            }, className: classnames(s['popper-wrapper'], wrapperClassName) },
            React.createElement("div", { className: classnames(s['popper-content'], height && s['with-scroll'], contentClassName), style: { width: width, height: height } }, children),
            showArrow && arrowProps && (React.createElement("div", { ref: arrowProps.ref, className: classnames(s['arrow'], arrowClassName), style: getArrowPositionStyles(arrowProps) })))));
};
PopperLayout.displayName = 'PopperLayout';
export default PopperLayout;
//# sourceMappingURL=PopperLayout.js.map